import React, { useCallback, useEffect, useState } from 'react';
import type { AdminAccount } from '../types';
import { createAdminAccount, deleteAdminAccount, fetchAdminAccounts } from '../api/admin';
import { AdminAccountModal } from './AdminAccountModal';
import { ConfirmDialog } from './ConfirmDialog';

export function AdminAccountsSection() {
  const [accounts, setAccounts] = useState<AdminAccount[]>([]);
  const [loadError, setLoadError] = useState<string | null>(null);
  const [showCreate, setShowCreate] = useState(false);
  const [toDelete, setToDelete] = useState<AdminAccount | null>(null);

  const load = useCallback(async () => {
    setLoadError(null);
    try {
      setAccounts(await fetchAdminAccounts());
    } catch (err) {
      setLoadError(err instanceof Error ? err.message : 'Konten konnten nicht geladen werden.');
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return (
    <div className="data-section">
      <div className="section-header">
        <h2>Admin-Konten</h2>
        <button type="button" className="medieval-button" onClick={() => setShowCreate(true)}>
          + Konto anlegen
        </button>
      </div>
      <p className="section-info">Hauptkonto aus ADMIN_USERNAME / ADMIN_PASSWORD. Weitere Spielleiter hier anlegen.</p>
      {loadError && <p className="form-error" role="alert">{loadError}</p>}
      <div className="data-grid">
        {accounts.map(account => (
          <div key={account.id} className="data-card">
            <h3>{account.username}</h3>
            <p>
              <strong>Typ:</strong> {account.is_bootstrap ? 'Container-Hauptkonto' : 'Zusätzliches Konto'}
            </p>
            {account.is_bootstrap ? (
              <p className="section-info">Passwort wird über die Umgebungsvariable gesetzt.</p>
            ) : (
              <div className="card-actions">
                <button type="button" className="delete-button" onClick={() => setToDelete(account)}>
                  Löschen
                </button>
              </div>
            )}
          </div>
        ))}
      </div>
      {showCreate && (
        <AdminAccountModal
          onClose={() => setShowCreate(false)}
          onSubmit={async (username, password) => {
            await createAdminAccount(username, password);
            setShowCreate(false);
            await load();
          }}
        />
      )}
      {toDelete && (
        <ConfirmDialog
          title="Admin-Konto löschen?"
          message={`„${toDelete.username}“ wirklich löschen? Das Konto kann sich danach nicht mehr anmelden.`}
          confirmLabel="Löschen"
          danger
          onCancel={() => setToDelete(null)}
          onConfirm={() => {
            void deleteAdminAccount(toDelete.id)
              .then(() => load())
              .finally(() => setToDelete(null));
          }}
        />
      )}
    </div>
  );
}
